<script setup>
import {computed, nextTick, onMounted, ref} from 'vue'
import {useRouter} from 'vue-router'
import {useFormsStore} from '@/stores/forms'
import {usePageEditorStore} from '@/stores/pageEditor'
import {useSiteTreeStore} from '@/stores/siteTree'
import Button from "@/common/Button.vue"
import Form from "@/common/form/Form.vue"
import FormSaveBtn from "@/common/form/FormSaveBtn.vue"

const router = useRouter()
const pageEditorStore = usePageEditorStore()
const formsStore = useFormsStore()

const btn = ref(null)
const offcanvas = ref(null)

const tableName = 'pages'
const id = 0
const formId = ref('')

const siteTreeId = computed(() => pageEditorStore.siteTreeId)
const siteTreeStore = computed(() => siteTreeId.value ? useSiteTreeStore(siteTreeId.value) : null)
const selectedNavigationGroup = computed(() => siteTreeStore.value?.selectedNavigationGroup)

const createForm = async () => {
    formId.value = `form:${tableName}:${id}`

    await formsStore.createForm({
        tableName: tableName,
        id: id,
        fieldNames: [
            'title',
            'url',
            'templateId',
            'type',
            'componentId',
            'parent',
            'navigation'
        ],
        currentData: {
            navigation: selectedNavigationGroup.value
        },
        onSave: async (o) => {
            const pageId = o.id

            pageEditorStore.newPage = true

            await router.push({name: 'pageEditor', params: {pageId: pageId}})

            if (btn.value?.$el) {
                btn.value.$el.click()
            }

            if (siteTreeStore.value) {
                await siteTreeStore.value.init()
                siteTreeStore.value.setSelectedPageId(pageId)
            }
        }
    })

    nextTick(() => {
        if (offcanvas.value) {
            const titleField = offcanvas.value.querySelector('[name="title"]')
            if (titleField) {
                titleField.focus()
            }
        }
    })
}

onMounted(() => {
    const offcanvasNode = document.getElementById('pageEditorAddPageOffCanvas')

    if (offcanvasNode) {
        offcanvasNode.addEventListener('shown.bs.offcanvas', () => {
            createForm()
        })

        offcanvasNode.addEventListener('hidden.bs.offcanvas', () => {
            formId.value = ''
        })
    }
})
</script>

<template>
    <div class="d-inline-block">
        <Button ref="btn" class="rounded-0" data-bs-toggle="offcanvas" data-bs-target="#pageEditorAddPageOffCanvas"
                aria-controls="pageEditorAddPageOffCanvas" title="Add page"><i class="bi bi-plus-lg"/></Button>

        <div ref="offcanvas" class="offcanvas offcanvas-start" tabindex="-1" id="pageEditorAddPageOffCanvas"
             aria-labelledby="pageEditorAddPageOffCanvasLabel">
            <div class="offcanvas-header">
                <h5 class="offcanvas-title" id="pageEditorAddPageOffCanvasLabel">Add page</h5>
                <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>

            <div class="offcanvas-body">
                <Form v-if="formId" :form-id="formId" :show-field-names="true" :hide-help-text="true"/>
            </div>

            <div class="offcanvas-footer text-end p-3">
                <FormSaveBtn v-if="formId" :form-id="formId" :cancel-on-save="true" :button-text="'Save'"/>
            </div>
        </div>
    </div>
</template>